/*global window, twttr, twttr.events, twttr.events._handlers, TWTR1and1 */
var $ = require('jquery');
var ShareButton = require('diy/social/ShareButton');
var websiteData = require('diy/util/websiteData');

var TwitterShare;


/**
 * @class diy.social.TwitterShare
 * @template diy.social.TwitterShare
 * @lends {diy.social.TwitterShare.prototype}
 * @extends {diy.social.ShareButton}
 * @constructor
 */
TwitterShare = ShareButton.extend({
    /**
     * @type {{
     *    url: String,
     *    image: String | undefined,
     *    onClick: Function | undefined,
     *    onSubmit: Function | undefined,
     *    message: {
     *        text: String | undefined,
     *        tags: String | undefined
     *    } | undefined,
     * }}
     */
    options: undefined,
    /**
     *
     * @param {*} options
     * @private
     * @returns {diy.social.TwitterShare}
     */
    setOptions: function (options) {
        var
            defaults = {
                appId: '',
                onClick: undefined,
                onSubmit: undefined,
                onSubmitCanceled: undefined,
                image: websiteData.getCdnUrl() + 's/diy/social/img/twitter/twitter_' + this.market + '.png',
                url: websiteData.getWebUrl(),

                actions: []
            };

        this.options = $.extend(true, {}, defaults, options);
        return this;
    },
    /**
     * @private
     * @returns {Promise|Q.promise}
     */
    loadApi: function () {
        var deferred = Q.defer();


        if (typeof window.twttr === 'undefined') {
            window.twttr = (function (d, s, id) {
                var t, js, fjs = d.getElementsByTagName(s)[0];
                if (d.getElementById(id)) {
                    return;
                }
                js = d.createElement(s);
                js.id = id;
                js.src = "https://platform.twitter.com/widgets.js";
                fjs.parentNode.insertBefore(js, fjs);
                return window.twttr || (t = {
                        _e: [], ready: function (f) {
                            t._e.push(f);
                        }
                    });
            }(document, "script", "twitter-wjs"));
            // we set this to true so after loading widgets.js from twitter
            // we no longer use the webintents defined in moduleserver
            TWTR1and1.UseExternalIntentHandler = true;
        }

        if (typeof window.twttr.widgets === 'undefined') {
            window.twttr.ready(function () {
                deferred.resolve(true);
            });
        } else {
            deferred.resolve(true);
        }

        return deferred.promise;
    },
    /**
     * @private
     */
    createButton: function () {
        var $share, params;

        params = $.param({
            /**
             * url: this.options.url, // remove url because exists in text
             * if url is null or empty string twitter adds automatically the page url
             *      see (https://dev.twitter.com/docs/tweet-button)
             *      so we add a space
             */
            url: (this.options.url === null)? ' ' : this.options.url,
            lang: this.language,
            text: this.options.message.text,
            hashtags: this.options.message.tags
        });
        $share = $(
            [
                '<a href="https://twitter.com/intent/tweet?' + params + '">',
                '<img src="' + this.options.image + '">',
                '</a>'
            ].join("")
        ).appendTo(this.$element);

        $share.css({cursor: 'pointer'});

        if (window.twttr.events._handlers && window.twttr.events._handlers.click) {
            window.twttr.events.unbind('click');
        }
        if (window.twttr.events._handlers && window.twttr.events._handlers.tweet) {
            window.twttr.events.unbind('tweet');
        }

        window.twttr.events.bind('click', this.onClick.bind(this));
        window.twttr.events.bind('tweet', this.onSubmit.bind(this));
    },
    /**
     * @private
     */
    onClick: function () {
        this.executeCallback(this.options.onClick);
    },
    /**
     * @param {{undefined|{post_id: String|undefined}} callbackData
     * @private
     */
    onSubmit: function (callbackData) {
        this.executeCallback(this.options.onSubmit, callbackData);
    }

});

module.exports = TwitterShare;



/*****************
 ** WEBPACK FOOTER
 ** ./source/cdn/document_root/s/diy/social/TwitterShare.js
 ** module id = 738
 ** module chunks = 0
 **/